export default "/_next/static/fonts/0ea16d1de9656732d295a2886e19b9a0.woff";